import { Badge, Box, FlexLayout, H4, Icon } from '@deity/falcon-ui';
import type { FC } from 'react';

interface FieldInfoProps {
  type: string;
  fieldName: string;
  fieldPath: string[];
}
const FieldInfo: FC<FieldInfoProps> = ({ type, fieldName, fieldPath }) => (
  <Box>
    <FlexLayout alignItems="center" style={{ minHeight: '32px' }}>
      <H4 fontWeight="bold" fontSize="xl">
        {fieldName}
      </H4>
      <Badge ml="xs" bg="lightGrey" borderColor="border">
        <Icon fill="badgeText" stroke="transparent" src={type} fallback="dict" css={{ width: 18 }} mr="xs" />
        <H4 color="badgeText" fontWeight="bold" fontSize="sm">
          {type}
        </H4>
      </Badge>
    </FlexLayout>
    <H4 mt="xs" fontSize="lg" color="labelText" style={{ wordWrap: 'break-word' }}>
      {fieldPath.join('.')}
    </H4>
  </Box>
);

export default FieldInfo;
